<template>
  <div class="bg-white p-2">
    <!-- Paneller -->
    <right-panel class="float-right" id="sidebar-inventory-node" width="700px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5" v-if="editedNode">
        <InventoryNodeForm id="sidebar-inventory-node" :node="editedNode" :process="editedNode.process" @onSaved="paginate" />
      </div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-data-disposal-method" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DataDisposalMethodForm /></div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-data-access-and-restriction" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DataAccessAndRestrictionForm id="sidebar-new-data-access-and-restriction" /></div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-datasubject-transfering" width="1250px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DatasubjectTransferingForm id="sidebar-new-datasubject-transfering" /></div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-datasubject-processing-legal" width="1000px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DatasubjectProcessingLegalForm id="sidebar-new-datasubject-processing-legal" /></div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-datasubject-auto-processing" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DataSubjectAutoProcessingForm @onSaved="onFeatureSaved" /></div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-new-datasubject-datasubject-right" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5"><DatasubjectDatasubjectRightForm /></div>
    </right-panel>
    <template v-if="columnOptions.datasourceFeatures">
      <right-panel class="float-right" id="sidebar-new-datasource-direct-collect-method" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourceDirectCollectMethodForm /></div></right-panel>
      <right-panel class="float-right" id="sidebar-new-datasource-other-collect-method" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourceOtherCollectMethodForm /></div></right-panel>
      <right-panel class="float-right" id="sidebar-new-datasource-physical-archive" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourcePhysicalArchiveForm /></div></right-panel>
      <right-panel class="float-right" id="sidebar-new-datasource-electronic-archive" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourceElectronicArchiveForm /></div></right-panel>
      <right-panel class="float-right" id="sidebar-new-datasource-physical-storage" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourcePhysicalStorageForm id="sidebar-new-datasource-physical-storage" /></div></right-panel>
      <right-panel class="float-right" id="sidebar-new-datasource-electronic-storage" width="600px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><DatasourceElectronicStorageForm /></div></right-panel>
      <right-panel class="float-right" id="sidebar-storage-retention" width="500px" @hidden="rightPanelClosed"><div class="pl-5 pr-5"><StorageRetentionForm id="sidebar-storage-retention" :item="retentionItem" :kind="retentionKind" /></div></right-panel>
    </template>

    <!-- TKP-64 / s.4 md.1: satır kapsamlı toplu güncelleme (her seviyeden tüm özellikler); kapanınca tablo filtresi geri gelir -->
    <right-panel class="float-right" id="sidebar-row-bulk-update" width="1300px" @hidden="rowBulkUpdateClosed">
      <BulkUpdateView v-if="rowBulkScope" :showScope="false" @onUpdated="onRowBulkUpdated" />
    </right-panel>

    <div class="float-right d-flex">
      <b-dropdown split split-href="#" :text="$t('inventory.options')" size="sm" variant="light" class="m-2">
        <b-dropdown-item @click="downloadInventory()" href="#">{{ $t("common.download") }}</b-dropdown-item>
        <b-dropdown-item @click="downloadInventory(true)" href="#">{{ $t("inventory.save-to-files") }}</b-dropdown-item>
      </b-dropdown>
      <InventoryFilter id="sidebar-inventory-filter" @apply="paginate" />
      <BulkUpdate @applyFilter="paginate" />
      <sweet-button @click="fullscreen = true" variant="main" icon="bx bx-expand" size="sm" buttonClass="ml-3  mt-2">{{ $t("common.fullscreen") }}</sweet-button>
    </div>

    <!-- TKP-127: özellik görünümleri TEK SEÇİMLİ (TKP-27 6.2'de birbirini dışlamıyordu; üçü birden açılınca ekran bozuluyordu).
         Birine basınca o açılır ötekiler kapanır; açık olana basınca kapanır — hiçbiri açık değilse temel tablo. -->
    <div class="float-left pb-2 btn-group btn-group-sm" role="group" data-test="feature-views">
      <button
        v-for="view in featureViews"
        :key="view.key"
        type="button"
        class="btn"
        :class="featureView === view.key ? 'btn-primary' : 'btn-outline-secondary'"
        :aria-pressed="featureView === view.key"
        :data-test="'feature-view-' + view.key"
        :disabled="isLoading"
        @click="toggleFeatureView(view.key)"
      >
        {{ $t(view.label) }}
      </button>
    </div>
    <br style="clear:both" />

    <div class="inventory-table" :class="fullscreen ? 'fullscreen' : ''">
      <button class="btn btn-sm btn-main btn-exit" v-if="fullscreen" @click="fullscreen = false">{{ $t("common.close") }}</button>
      <!-- TKP-201 (TKP-200 m.8): TEK tablo, dizin Birim › Süreç › Veri › İlgili Kişi › Veri Kaynağı; satır = veri × ilgili kişi
           (ilgili kişisi olmayan veri tek satır). Üç özellik görünümünün sütunları satır başına: hücrede satırın değerleri —
           TKP-195 seviyelerinin birleşimi (verinin kendi kaydı + satırın kendi kaydı + kaynağın eski kaydı, soluk/salt okunur).
           Eskiden İmha/Erişim veri başına tek hücreydi (satır kayıtları görünmüyordu), Toplama/Saklama/Arşiv ayrı tabloydu. -->
      <table v-if="!isLoading && pagination && pagination.docs.length > 0" class="table table-sm inv" data-test="inventory-table">
        <thead>
          <tr>
            <th class="sticky-col c1">{{ $t("department.text") }}</th>
            <th class="sticky-col c2">{{ $t("process.text") }}</th>
            <th class="sticky-col c3">{{ $t("data.text") }}</th>
            <th data-test="head-datasubject" class="sticky-col c-ds">{{ $t("datasubject.text") }}</th>
            <th data-test="head-datasource" class="c-src">{{ $t("datasource.text") }}</th>
            <template v-if="columnOptions.datasubjectFeatures">
              <th class="bg-soft-inventory c-pl">{{ $t("processing.text") }}</th>
              <th class="bg-inventory c-tr">{{ $t("transfering.text") }}</th>
              <th class="bg-soft-inventory c-rt">{{ $t("datasubject-right.text") }}</th>
            </template>
            <template v-if="columnOptions.nodeFeatures">
              <th class="bg-soft-inventory">{{ $t("disposal-method.text") }}</th>
              <th class="bg-soft-inventory">{{ $t("disposal-method.periodic") }}</th>
              <th class="bg-inventory">{{ $t("accessing-persons.text") }}</th>
            </template>
            <template v-if="columnOptions.datasourceFeatures">
              <th v-for="f in datasourceFeatureGroups" :key="f.key" class="bg-soft-inventory" :data-test="'head-' + f.key">{{ $t(f.label) }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <template v-for="department in pagination.docs">
            <template v-for="(process, pi) in department.processes">
              <template v-for="(node, ni) in process.processDatas">
                <tr v-for="(datasubject, ri) in rowsOf(node)" :key="node._id + '-' + (datasubject ? datasubject._id : 'none')" class="node-row hider" data-test="inv-row">
                  <td v-if="pi === 0 && ni === 0 && ri === 0" class="sticky-col c1" :rowspan="rowspanOfDepartment(department)">
                    {{ department.name | translate }} <i v-if="!bulkLocked" class="bx bx-customize text-primary hand ml-1" v-b-tooltip.hover :title="$t('inventory.row-bulk-update')" @click="openRowBulkUpdate('department', { department })"></i>
                    <inventory-note class="hidden" store="organizationDepartment" :payload="department" />
                  </td>
                  <td v-if="ni === 0 && ri === 0" class="sticky-col c2" :rowspan="rowspanOfProcess(process)">
                    {{ process.name | translate }} <i v-if="!bulkLocked" class="bx bx-customize text-primary hand ml-1" v-b-tooltip.hover :title="$t('inventory.row-bulk-update')" @click="openRowBulkUpdate('process', { department, process })"></i>
                    <inventory-note class="hidden" store="organizationDepartmentProcess" :payload="process" />
                  </td>
                  <td v-if="ri === 0" class="sticky-col c3" :rowspan="rowsOf(node).length">
                    <div class="d-flex justify-content-between">
                      <b>{{ node.data && node.data.name | translate }}</b>
                      <span>
                        <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('inventory.node-form.title')" @click="editNode(node, process)"></i>
                        <i v-if="!bulkLocked" class="bx bx-customize text-primary hand ml-1" v-b-tooltip.hover :title="$t('inventory.row-bulk-update')" @click="openRowBulkUpdate('data', { department, process, node })"></i>
                      </span>
                    </div>
                    <div class="small text-muted">
                      <span v-if="node.category"><i class="bx bx-layer"></i> {{ node.category.name | translate }}<i v-if="node.categoryOverridden" class="bx bx-edit-alt ml-1" v-b-tooltip.hover :title="$t('process-data.category-override')"></i><i v-if="node.category.specialQualityData" class="bx bx-info-circle text-primary ml-1" v-b-tooltip.hover :title="$t('data-category.special-quality-data')"></i></span>
                    </div>
                    <inventory-note class="hidden" store="organizationProcessData" :payload="node" />
                  </td>
                  <td class="sticky-col c-ds" data-test="row-datasubject">
                    <template v-if="datasubject">
                      {{ datasubject.name | translate }} <i v-if="!bulkLocked" class="bx bx-customize text-primary hand ml-1 hidden" v-b-tooltip.hover :title="$t('inventory.row-bulk-update')" @click="openRowBulkUpdate('datasubject', { department, process, node, datasubject })"></i>
                      <inventory-note class="hidden" store="organizationDataDatasubject" :payload="datasubject" />
                    </template>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td class="c-src" data-test="node-datasources">
                    <span v-if="datasourceNames(node)"><i class="bx bx-data text-muted"></i> {{ datasourceNames(node) }}</span>
                    <span v-else class="font-italic text-muted">{{ $t("process-data.no-datasource") }}</span>
                  </td>
                  <!-- İşleme / Aktarım / İlgili kişi hakları: ilgili kişi satırının kayıtları -->
                  <template v-if="columnOptions.datasubjectFeatures">
                    <template v-if="datasubject">
                      <td class="sub-inventory c-pl">
                        <div v-if="datasubjectInventory[datasubject._id]">
                          <div v-for="pl in datasubjectInventory[datasubject._id].processingLegals" :key="pl._id">
                            <i class="bx bx-trash text-danger hand hidden" @click="deleteDatasubjectProcessingLegal(datasubject._id, pl._id)"></i>
                            {{ (pl.purpose && pl.purpose.name) | translate }} <span class="text-muted">/ {{ (pl.legalReason && pl.legalReason.name) | translate }}</span>
                            <span v-if="regulationOf(pl.legalReason)" class="text-muted small" data-test="pl-regulation">({{ regulationOf(pl.legalReason) }})</span>
                            <span v-if="pl.legitimateInterest" class="text-muted"><br /><b>{{ $t("processing-transfering.legitimate-interest.text") }}:</b> {{ pl.legitimateInterest | translate }}</span>
                          </div>
                          <span class="text-primary hand hidden" @click="createDatasubjectProcessingLegal(datasubject)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                          <span class="text-warning hand hidden ml-2" @click="editDatasubjectProcessingLegal(datasubject, datasubjectInventory[datasubject._id].processingLegals)"><i class="bx bx-pencil"></i></span>
                          <div class="small mt-1">
                            <span class="text-muted">{{ $t("processing.auto") }}:</span> {{ datasubject.feature && datasubject.feature.autoProcessing ? $t("common.yes") : $t("common.no") }}
                            · <span class="text-muted">{{ $t("processing.ai") }}:</span> {{ datasubject.feature && datasubject.feature.aiProcessing ? $t("common.yes") : $t("common.no") }}
                            <i class="bx bx-pencil text-warning hand hidden ml-1" @click="editProcessingFeature(datasubject)"></i>
                          </div>
                        </div>
                      </td>
                      <td class="sub-inventory c-tr">
                        <div v-if="datasubjectInventory[datasubject._id]">
                          <div v-for="tr in datasubjectInventory[datasubject._id].transferings" :key="tr._id" class="border-bottom mb-1">
                            <b>{{ tr.thirdParty && tr.thirdParty.name | translate }}</b> <i v-if="tr.thirdParty" class="text-muted">({{ tr.thirdParty.receiverGroup && tr.thirdParty.receiverGroup.name | translate }})</i>
                            <span class="text-warning hand hidden float-right" @click="editDatasubjectTransfering(datasubject, tr)"><i class="bx bx-pencil"></i></span>
                            <span class="text-danger hand hidden float-right mr-2" @click="deleteDatasubjectTransfering(datasubject._id, tr._id)"><i class="bx bx-trash"></i></span>
                            <div v-for="legal in tr.legals" :key="tr._id + ((legal.legalReason && legal.legalReason.libraryItem && legal.legalReason.libraryItem._id) || '') + ((legal.purpose && legal.purpose.libraryItem && legal.purpose.libraryItem._id) || '')" class="small">{{ (legal.purpose && legal.purpose.name) | translate }} <span class="text-muted">/ {{ (legal.legalReason && legal.legalReason.name) | translate }}</span> <span v-if="regulationOf(legal.legalReason)" class="text-muted" data-test="tr-regulation">({{ regulationOf(legal.legalReason) }})</span></div>
                            <div class="small text-muted">{{ (tr.methods || []).map((m) => $options.filters.translate(m.name)).join(", ") }} <span v-if="tr.preventions && tr.preventions.length">· {{ tr.preventions.map((m) => $options.filters.translate(m.name)).join(", ") }}</span></div>
                          </div>
                          <span class="text-primary hand hidden" @click="createDatasubjectTransfering(datasubject)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                        </div>
                      </td>
                      <td class="sub-inventory c-rt">
                        <div v-if="datasubjectInventory[datasubject._id]">
                          <div v-for="r in datasubjectInventory[datasubject._id].datasubjectRights" :key="r._id"><i class="bx bx-trash text-danger hand hidden" @click="removeDatasubjectDatasubjectRigth(datasubject._id, r._id)"></i> {{ r.name | translate }}</div>
                          <span class="text-primary hand hidden" @click="addDatasubjectDatasubjectRight(datasubject)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                        </div>
                      </td>
                    </template>
                    <td v-else colspan="3" class="text-muted">-</td>
                  </template>
                  <!-- İmha / Erişim: verinin kendi kaydı + bu ilgili kişi satırının kendi kaydı (TKP-195) -->
                  <template v-if="columnOptions.nodeFeatures">
                    <td class="sub-inventory" data-test="row-disposal-methods">
                      <div v-for="dm in nodeItems(node, 'disposalMethods')" :key="'n' + dm._id"><i class="bx bx-trash text-danger hand hidden" @click="removeDisposalMethod(node._id, dm._id)"></i> {{ dm.name | translate }}</div>
                      <div v-for="dm in rowItems(datasubject, 'disposalMethods')" :key="'r' + dm._id" data-test="row-own"><i class="bx bx-trash text-danger hand hidden" @click="removeRowItem('dataDisposalMethod', dm._id)"></i> {{ dm.name | translate }}</div>
                      <span class="text-primary hand hidden" @click="addDisposalMethod(node)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                    </td>
                    <td class="sub-inventory" data-test="row-disposal-period">
                      <span>{{ rowDisposalPeriod(node, datasubject) | period }}</span>
                      <br /><span class="text-warning hand hidden" @click="editNode(node, process)"><i class="bx bx-pencil"></i> {{ $t("common.edit") }}</span>
                    </td>
                    <td class="sub-inventory" data-test="row-access">
                      <div v-for="(ar, i) in nodeItems(node, 'accessAndRestrictions')" :key="'n' + ar._id + i"><i class="bx bx-trash text-danger hand hidden" @click="removeAccessAndRestriction(node._id, ar._id)"></i> {{ ar.accessor && ar.accessor.name | translate }} <span v-if="ar.restriction" class="text-muted">/ {{ ar.restriction.name | translate }}</span></div>
                      <div v-for="(ar, i) in rowItems(datasubject, 'accessAndRestrictions')" :key="'r' + ar._id + i" data-test="row-own"><i class="bx bx-trash text-danger hand hidden" @click="removeRowItem('dataAccessAndRestriction', ar._id)"></i> {{ ar.accessor && ar.accessor.name | translate }} <span v-if="ar.restriction && ar.restriction.name" class="text-muted">/ {{ ar.restriction.name | translate }}</span></div>
                      <span class="text-primary hand hidden" @click="addAccessAndRestriction(node)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                    </td>
                  </template>
                  <!-- Toplama / Saklama / Arşiv: verinin kendi kaydı (düzenlenebilir) + bu satırın kaydı + kaynağın eski kaydı (salt okunur) -->
                  <template v-if="columnOptions.datasourceFeatures">
                    <td v-for="f in datasourceFeatureGroups" :key="f.key" class="sub-inventory" :data-test="'dv-cell-' + f.key">
                      <div v-for="item in ownFeatureItems(node, f.key)" :key="item._id" data-test="dv-own">
                        <i class="bx bx-trash text-danger hand hidden" @click="removeNodeFeature(f, node._id, item._id)"></i>
                        <span :class="{ hand: f.retention }" @click="f.retention && editRetention(f, item)">{{ item.name | translate }}<span v-if="item.period"> - {{ item.period | period }}</span></span>
                        <i v-if="f.retention" class="bx bx-pencil text-warning hand hidden" v-b-tooltip.hover :title="$t('storage-retention.edit')" @click="editRetention(f, item)"></i>
                        <div v-if="item.since || item.legalBasis" class="text-muted">
                          <span v-if="item.since">{{ item.since | translate }}</span><span v-if="item.since && item.legalBasis"> · </span><span v-if="item.legalBasis">{{ item.legalBasis | translate }}</span>
                        </div>
                      </div>
                      <div v-for="item in datasubject ? rowFeatureItems(datasubject, f.key) : []" :key="'r' + item._id" data-test="dv-row-own">
                        <i class="bx bx-trash text-danger hand hidden" @click="removeRowItem(f.store, item._id)"></i>
                        {{ item.name | translate }}<span v-if="item.period"> - {{ item.period | period }}</span>
                      </div>
                      <template v-for="pd in nodeProcessDatasources(process, node)">
                        <div v-for="item in datasourceItems(pd, f.key)" :key="pd._id + item._id" class="text-muted small" data-test="dv-source" v-b-tooltip.hover :title="$t('inventory.source-record-hint')">
                          <i class="bx bx-data"></i> {{ $t("datasource.text") }}: {{ (pd.datasource && pd.datasource.name) || pd.name | translate }} — {{ item.name | translate }}<span v-if="item.period"> - {{ item.period | period }}</span>
                        </div>
                      </template>
                      <span class="text-primary hand hidden" @click="addNodeFeature(f, node)"><i class="bx bx-plus"></i> {{ $t("common.add") }}</span>
                    </td>
                  </template>
                </tr>
              </template>
              <tr v-if="process.processDatas.length == 0" :key="process._id + '-empty'">
                <td v-if="pi === 0" class="sticky-col c1" :rowspan="rowspanOfDepartment(department)">{{ department.name | translate }}</td>
                <td class="sticky-col c2">{{ process.name | translate }}</td>
                <td :colspan="colspanRest" class="text-muted">-</td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>

      <div v-if="pagination" class="row mt-3">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="20" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <content-loading v-if="isLoading" />
    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">{{ $t("common.not-found") }}</h5>
    </empty>
  </div>
</template>

<script>
import BulkLock from "@/modules/approval/bulk-lock"; // TKP-130
import { columnOptionsFor, datasourceNamesOf, FEATURE_VIEWS, inventoryRowsOf, nextFeatureView, nodeProcessDatasources, rowDisposalPeriodOf } from "./feature-views";
import DataAccessAndRestrictionForm from "@modules/inventory/component/access-and-restriction/data-access-and-restriction-form";
import BulkUpdate from "@modules/inventory/component/bulk-update/bulk-update";
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import { rowBulkCommits } from "@modules/inventory/helpers/row-bulk-scope";
import DatasubjectDatasubjectRightForm from "@modules/inventory/component/datasubject-right/datasubject-datasubject-right-form";
import DatasourceDirectCollectMethodForm from "@modules/inventory/component/direct-collect-method/datasource-direct-collect-method-form";
import DataDisposalMethodForm from "@modules/inventory/component/disposal-method/data-disposal-method-form";
import DatasourceElectronicArchiveForm from "@modules/inventory/component/electronic-archive/datasource-electronic-archive-form";
import DatasourceElectronicStorageForm from "@modules/inventory/component/electronic-storage/datasource-electronic-storage-form";
import InventoryFilter from "@modules/inventory/component/filter/inventory-filter";
import InventoryNodeForm from "@modules/inventory/component/node/inventory-node-form";
import DatasourceOtherCollectMethodForm from "@modules/inventory/component/other-collect-method/datasource-other-collect-method-form";
import DatasourcePhysicalArchiveForm from "@modules/inventory/component/physical-archive/datasource-physical-archive-form";
import DatasourcePhysicalStorageForm from "@modules/inventory/component/physical-storage/datasource-physical-storage-form";
import StorageRetentionForm from "@modules/inventory/component/retention/storage-retention-form";
import DataSubjectAutoProcessingForm from "@modules/inventory/component/processing/datasubject-auto-processing-form";
import DatasubjectProcessingLegalForm from "@modules/inventory/component/processing/datasubject-legal-form";
import DatasubjectTransferingForm from "@modules/inventory/component/transfering/datasubject-transfering-form";
import { EventBus } from "@modules/websocket";
import InventoryNote from "./component/inventory-note.vue";
import { flattenCopySources, indexDatasubjectRows } from "./helpers/copy-sources";

/**
 * TKP-27 / Faz 6 dilim 6.2 — envanter düzenleme: satır = süreç×veri DÜĞÜMÜ (birim → süreç → düğüm → ilgili kişi);
 * kaynak/veri/ilgili kişi seviye kısıtı yok, özellik grupları birlikte açılır, düğümün tüm özellikleri tek formdan
 * (`InventoryNodeForm`). Kaynağa bağlı 6 özellik (K5) süreç satırının altında sürecin kaynaklarıyla.
 */
/** TKP-126: düğümün kendi (veri seviyeli) toplama/saklama/arşiv kayıtları — `fetch-process-data` cevabındaki `own`. */
export const ownFeaturesOf = (nodeInventory, nodeId, key) => ((((nodeInventory || {})[nodeId] || {}).own || {})[key]) || [];

const DATASOURCE_FEATURES = [
  { key: "directCollectMethods", label: "direct-collect-method.text", store: "datasourceDirectCollectMethod", panel: "sidebar-new-datasource-direct-collect-method", remove: "removeDirectCollectMethod", idKey: "directCollectMethodId" },
  { key: "otherCollectMethods", label: "other-collect-method.text", store: "datasourceOtherCollectMethod", panel: "sidebar-new-datasource-other-collect-method", remove: "removeOtherCollectMethod", idKey: "otherCollectMethodId" },
  { key: "physicalStorages", label: "physical-storage.text", store: "datasourcePhysicalStorage", panel: "sidebar-new-datasource-physical-storage", remove: "removePhysicalStorage", idKey: "physicalStorageId", edited: "editedPhysicalStorage", retention: "physical" },
  { key: "electronicStorages", label: "electronic-storage.text", store: "datasourceElectronicStorage", panel: "sidebar-new-datasource-electronic-storage", remove: "removeElectronicStorage", idKey: "electronicStorageId", edited: "editedElectronicStorage", retention: "electronic" },
  { key: "physicalArchives", label: "physical-archive.text", store: "datasourcePhysicalArchive", panel: "sidebar-new-datasource-physical-archive", remove: "removePhysicalArchive", idKey: "physicalArchiveId" },
  { key: "electronicArchives", label: "electronic-archive.text", store: "datasourceElectronicArchive", panel: "sidebar-new-datasource-electronic-archive", remove: "removeElectronicArchive", idKey: "electronicArchiveId" },
];

export default {
  mixins: [BulkLock],
  props: ["product"],
  components: {
    DatasourceDirectCollectMethodForm, DatasourceOtherCollectMethodForm, DatasourcePhysicalArchiveForm, DatasourceElectronicArchiveForm, DatasourcePhysicalStorageForm, DatasourceElectronicStorageForm,
    DataDisposalMethodForm, DataAccessAndRestrictionForm, DatasubjectTransferingForm, DatasubjectProcessingLegalForm, DatasubjectDatasubjectRightForm, DataSubjectAutoProcessingForm,
    InventoryFilter, BulkUpdate, InventoryNote, InventoryNodeForm, StorageRetentionForm, BulkUpdateView,
  },
  data() {
    return {
      fullscreen: false,
      columnOptions: columnOptionsFor(null),
      featureView: null,
      featureViews: FEATURE_VIEWS,
      retentionItem: null,
      rowBulkScope: null,
      criteriaBeforeRowBulk: null,
      retentionKind: "physical",
      request: { options: { page: 1, limit: 50 }, query: {} },
      editedNode: undefined,
      datasourceFeatureGroups: DATASOURCE_FEATURES,
    };
  },
  computed: {
    productInventoryStore() {
      return this.product == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
    pagination() {
      return this.$store.getters[this.productInventoryStore + "/pagination"];
    },
    isLoading() {
      return this.$store.getters[this.productInventoryStore + "/isLoading"];
    },
    nodeInventory() {
      return this.$store.getters[this.productInventoryStore + "/processDataInventory"];
    },
    datasourceInventory() {
      return this.$store.getters[this.productInventoryStore + "/datasourceInventory"];
    },
    datasubjectInventory() {
      return this.$store.getters[this.productInventoryStore + "/datasubjectInventory"];
    },
    rowsById() {
      return indexDatasubjectRows(this.pagination?.docs ?? []);
    },
    colspanRest() {
      // TKP-201: Veri + İlgili Kişi + Veri Kaynağı, sonra açık görünümün sütunları (Toplama/Saklama/Arşiv artık aynı tabloda: 6)
      return 3 + (this.columnOptions.nodeFeatures ? 3 : 0) + (this.columnOptions.datasubjectFeatures ? 3 : 0) + (this.columnOptions.datasourceFeatures ? DATASOURCE_FEATURES.length : 0);
    },
  },
  watch: {
    "columnOptions.nodeFeatures"(v) { if (v) { this.fetchNodeInventory(); this.fetchDatasubjectInventory(); } }, // TKP-201: satır kayıtları da
    "columnOptions.datasubjectFeatures"(v) { if (v) this.fetchDatasubjectInventory(); },
    "columnOptions.datasourceFeatures"(v) { if (v) { this.fetchNodeInventory(); this.fetchDatasourceInventory(); this.fetchDatasubjectInventory(); } }, // TKP-129: veri + kaynak kayıtları; TKP-196: satır kayıtları
    request: { deep: true, immediate: true, handler() { this.debounce(() => this.paginate()); } },
  },
  mounted() {
    EventBus.$on("sync", (data) => {
      if (data?.bulkUpdateProcessDone && data?.organization._id == this.currentOrganization._id) {
        if (data.refreshRequired) this.paginate();
        else this.refreshFeatures();
      }
    });
  },
  methods: {
    toggleFeatureView(key) {
      this.featureView = nextFeatureView(this.featureView, key);
      this.columnOptions = columnOptionsFor(this.featureView);
    },
    /** TKP-183 md.8: düğümün kaynak adları (virgülle; kaynak yoksa boş). */
    datasourceNames(node) {
      return datasourceNamesOf(node, this.$options.filters.translate);
    },
    nodeProcessDatasources(process, node) {
      return nodeProcessDatasources(process, node);
    },
    datasourceItems(datasource, key) {
      return ((this.datasourceInventory || {})[datasource._id] || {})[key] || [];
    },
    rowspanOfDepartment(department) {
      return department.processes.reduce((n, p) => n + this.rowspanOfProcess(p), 0) || 1;
    },
    rowspanOfProcess(process) {
      // TKP-201: satır = veri × ilgili kişi — süreç hücresi verilerinin bütün satırlarını kapsar (verisi yoksa tek satır)
      return Math.max(process.processDatas.reduce((n, node) => n + this.rowsOf(node).length, 0), 1);
    },
    /** TKP-201: verinin satırları — ilgili kişileri; yoksa tek boş satır (`null`). */
    rowsOf(node) {
      return inventoryRowsOf(node);
    },
    /** TKP-201: verinin (düğüm) kendi imha/erişim kayıtları. */
    nodeItems(node, key) {
      return ((this.nodeInventory || {})[node._id] || {})[key] || [];
    },
    /** TKP-201 / TKP-195: ilgili kişi satırının kendi imha/erişim kayıtları (boş satırda yok). */
    rowItems(datasubject, key) {
      return datasubject ? ((this.datasubjectInventory || {})[datasubject._id] || {})[key] || [] : [];
    },
    /** TKP-201: satırın saklama süresi — satırın kendisi verildiyse o, yoksa verinin. */
    rowDisposalPeriod(node, datasubject) {
      return rowDisposalPeriodOf((this.nodeInventory || {})[node._id], datasubject ? (this.datasubjectInventory || {})[datasubject._id] : null);
    },
    /** TKP-201: satır seviyesindeki kaydın silinmesi — store önbelleği satır kaydını taşımadığından envanter yeniden okunur. */
    async removeRowItem(store, id) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch(`${store}/delete`, id);
        this.$toast.success(this.$t("common.success"));
        this.refreshFeatures();
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },
    async paginate() {
      try {
        await this.$store.dispatch(this.productInventoryStore + "/paginateWith", { pagination: this.request, criteria: this.criteria });
        this.refreshFeatures();
      } catch (error) {
        console.error(error);
      }
    },
    refreshFeatures() {
      if (this.columnOptions.nodeFeatures) { this.fetchNodeInventory(); this.fetchDatasubjectInventory(); } // TKP-201
      if (this.columnOptions.datasubjectFeatures) this.fetchDatasubjectInventory();
      if (this.columnOptions.datasourceFeatures) { this.fetchNodeInventory(); this.fetchDatasourceInventory(); this.fetchDatasubjectInventory(); } // TKP-129 / TKP-196
    },
    nodes() {
      return (this.pagination?.docs ?? []).flatMap((d) => d.processes).flatMap((p) => p.processDatas);
    },
    async fetchNodeInventory() {
      const processDatas = this.nodes().map((n) => ({ _id: n._id }));
      if (!processDatas.length) return;
      try { await this.$store.dispatch(this.productInventoryStore + "/fetchProcessDataInventory", { processDatas }); } catch (error) {}
    },
    async fetchDatasourceInventory() {
      const datasources = (this.pagination?.docs ?? []).flatMap((d) => d.processes).flatMap((p) => p.datasources).map((ds) => ({ _id: ds._id }));
      if (!datasources.length) return;
      try { await this.$store.dispatch(this.productInventoryStore + "/fetchDatasourceInventory", { datasources }); } catch (error) {}
    },
    async fetchDatasubjectInventory() {
      const datasubjects = this.nodes().flatMap((n) => n.datasubjects).map((r) => ({ _id: r._id }));
      if (!datasubjects.length) return;
      try {
        await this.$store.dispatch(this.productInventoryStore + "/fetchDatasubjectInventory", { datasubjects });
        // TKP-27 / 6.2 (kriter 4): kopyalama kısayolu kaynakları — sayfadaki tüm aktarımlar
        this.$store.commit("datasubjectTransfering/copySources", flattenCopySources(this.datasubjectInventory, this.rowsById, (n) => this.$options.filters.translate(n)));
      } catch (error) {}
    },

    // ---- düğüm (tek form)
    editNode(node, process) {
      this.editedNode = { ...node, process };
      this.$root.$emit("bv::toggle::collapse", "sidebar-inventory-node");
    },
    nodeAsEditedData(node) {
      return { _id: node._id, name: node.data?.name, processData: { _id: node._id } };
    },
    addDisposalMethod(node) {
      this.$store.commit("dataDisposalMethod/editedData", this.nodeAsEditedData(node));
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-disposal-method");
    },
    async removeDisposalMethod(processDataId, disposalMethodId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch("dataDisposalMethod/delete", disposalMethodId);
        this.$store.commit(this.productInventoryStore + "/removeProcessDataDisposalMethod", { processDataId, disposalMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },
    addAccessAndRestriction(node) {
      this.$store.commit("dataAccessAndRestriction/editedData", this.nodeAsEditedData(node));
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-access-and-restriction");
    },
    async removeAccessAndRestriction(processDataId, accessAndRestrictionId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch("dataAccessAndRestriction/delete", accessAndRestrictionId);
        this.$store.commit(this.productInventoryStore + "/removeProcessDataAccessAndRestriction", { processDataId, accessAndRestrictionId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },

    // ---- kaynağa bağlı 6 özellik (K5)
    addDatasourceFeature(f, datasource) {
      this.$store.commit(`${f.store}/editedDatasource`, datasource);
      if (f.edited) this.$store.commit(`${f.store}/${f.edited}`, {});
      this.$root.$emit("bv::toggle::collapse", f.panel);
    },
    /** TKP-126: verinin kendi kaydı — `processDatasources` değil düğüm. Form kaydı TKP-74 ile düğüm seviyesine yazar. */
    ownFeatureItems(node, key) {
      return ownFeaturesOf(this.nodeInventory, node._id, key);
    },
    /** TKP-195/196: ilgili kişi satırının kendi kaydı (altı kaynak özelliği, `fetch-datasubject` → own). */
    rowFeatureItems(datasubject, key) {
      return (((this.datasubjectInventory || {})[datasubject._id] || {}).own || {})[key] || [];
    },
    addNodeFeature(f, node) {
      this.$store.commit(`${f.store}/editedDatasource`, null);
      this.$store.commit(`${f.store}/editedProcessData`, { _id: node._id });
      if (f.edited) this.$store.commit(`${f.store}/${f.edited}`, {});
      this.$root.$emit("bv::toggle::collapse", f.panel);
    },
    async removeNodeFeature(f, processDataId, itemId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch(`${f.store}/delete`, itemId);
        this.$store.commit(`${this.productInventoryStore}/removeProcessDataOwnFeature`, { processDataId, key: f.key, itemId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },
    // TKP-64 / s.4 md.1: tablo filtresi saklanır, kriter satır kapsamına çevrilir, panel kapanınca eski filtre geri yüklenir
    openRowBulkUpdate(level, scope) {
      const commits = rowBulkCommits(level, scope);
      this.criteriaBeforeRowBulk = JSON.parse(JSON.stringify(this.$store.getters["inventoryFilter/criteria"] ?? {}));
      this.$store.commit("inventoryFilter/clear");
      commits.forEach(([mutation, value]) => this.$store.commit(`inventoryFilter/${mutation}`, value));
      this.rowBulkScope = { level, commits };
      this.$root.$emit("bv::toggle::collapse", "sidebar-row-bulk-update");
    },
    onRowBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-row-bulk-update");
    },
    rowBulkUpdateClosed() {
      if (!this.rowBulkScope) return;
      this.$store.commit("inventoryFilter/criteria", this.criteriaBeforeRowBulk ?? {});
      this.rowBulkScope = null;
      this.criteriaBeforeRowBulk = null;
      this.paginate();
    },
    // TKP-64 / s.4 md.2: saklama kaydında başlangıç, süre, yasal dayanak ayrı düzenlenir
    editRetention(f, item) {
      this.retentionItem = item;
      this.retentionKind = f.retention;
      this.$root.$emit("bv::toggle::collapse", "sidebar-storage-retention");
    },
    async removeDatasourceFeature(f, datasourceId, itemId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch(`${f.store}/delete`, itemId);
        this.$store.commit(`${this.productInventoryStore}/${f.remove}`, { datasourceId, [f.idKey]: itemId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },

    // ---- ilgili kişi özellikleri (satır bazlı, değişmedi)
    /** TKP-241 p.9: hukuki sebebin regülasyonu (çalışma alanında girilen) — kayıtta yoksa kütüphane kaleminin ürüne göre regülasyonu. */
    regulationOf(legalReason) {
      if (!legalReason) return "";
      const translate = this.$options.filters.translate;
      const own = translate(legalReason.regulation);
      if (own) return own;
      const item = legalReason.libraryItem || {};
      return translate(this.$store.getters["product/currentProduct"] === "GDPR" ? item.gdprRegulation || item.regulation : item.kvkkRegulation || item.regulation) || "";
    },
    editDatasubjectTransfering(datasubject, transfering) {
      this.commitProcessingLegalSource(datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", transfering);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    // TKP-64: aktarım hukuki sebep panelindeki "işleme amaçlarını / hukuki sebeplerini yaz" seçenekleri bu satırdan okur
    commitProcessingLegalSource(datasubject) {
      this.$store.commit("datasubjectTransfering/processingLegalSource", this.datasubjectInventory[datasubject._id]?.processingLegals ?? []);
    },
    createDatasubjectTransfering(datasubject) {
      this.commitProcessingLegalSource(datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    async deleteDatasubjectTransfering(datasubjectId, transferingId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch("datasubjectTransfering/delete", transferingId);
        this.$store.commit(this.productInventoryStore + "/removeTransfering", { datasubjectId, transferingId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },
    editDatasubjectProcessingLegal(datasubject, processings) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", processings);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    createDatasubjectProcessingLegal(datasubject) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", null);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    async deleteDatasubjectProcessingLegal(datasubjectId, processingLegalId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch("datasubjectProcessingLegal/delete", processingLegalId);
        this.$store.commit(this.productInventoryStore + "/removeProcessingLegal", { datasubjectId, processingLegalId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },
    editProcessingFeature(datasubject) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-auto-processing");
    },
    onFeatureSaved(result) {
      const row = this.rowsById[result?._id];
      if (row) this.$set(row, "feature", { ...(row.feature ?? {}), ...result.feature });
      this.paginate();
    },
    addDatasubjectDatasubjectRight(item) {
      this.$store.commit("datasubjectDatasubjectRight/editedDatasubject", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-datasubject-right");
    },
    async removeDatasubjectDatasubjectRigth(datasubjectId, datasubjectDatasubjectRightId) {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      try {
        await this.$store.dispatch("datasubjectDatasubjectRight/delete", datasubjectDatasubjectRightId);
        this.$store.commit(this.productInventoryStore + "/removeDatasubjectDatasubjectRigth", { datasubjectId, datasubjectDatasubjectRightId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) { this.$handleHttpErrorByStatusCode(error); }
    },

    rightPanelClosed() {
      this.refreshFeatures();
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
      this.$store.commit("datasubjectTransfering/editedDatasubject", null);
      this.$store.commit("datasubjectTransfering/processingLegalSource", []);
      this.$store.commit("datasubjectProcessingLegal/showRecommendations", false);
      this.$store.commit("datasubjectTransfering/showRecommendations", false);
    },

    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
    async downloadInventory(saveInsteadofDownload = false) {
      if (saveInsteadofDownload && !(await this.confirm(this.$t("alert.approve")))) return;
      try {
        const { data: file } = await this.$store.dispatch(`gdprInventory/download`, saveInsteadofDownload);
        if (!saveInsteadofDownload) this.download(file);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inventory-table {
  overflow: auto;
  max-height: 100vh;
}
.inv {
  font-size: 10px;
  min-width: 1200px;
  td,
  th {
    vertical-align: top;
    border: 1px solid rgb(221 221 221);
    padding: 4px;
  }
  thead th {
    position: sticky;
    top: 0;
    background: #f8f9fa;
    z-index: 2;
  }
  .sticky-col {
    position: sticky;
    background: white;
    z-index: 1;
    min-width: 130px;
  }
  thead .sticky-col {
    z-index: 3;
    background: #f8f9fa;
  }
  /* TKP-233 m.147: İlgili Kişi de sabit (Birim, Süreç, Veri'den sonra). Sabit sütunların genişliği kesin — `left` ofsetleri tutsun */
  .c1 { left: 0; width: 130px; max-width: 130px; }
  .c2 { left: 130px; width: 130px; max-width: 130px; }
  .c3 { left: 260px; min-width: 180px; width: 180px; max-width: 180px; }
  .c-ds.sticky-col { left: 440px; min-width: 140px; width: 140px; max-width: 140px; }
  .node-row:hover > td { background-color: rgb(246, 251, 255); }
  /* TKP-201: iç tablo kalktı — her ilgili kişi satırı tablonun kendi satırı; sütunlar dış tabloda */
  .c-ds { min-width: 140px; } .c-src { min-width: 140px; } .c-pl { min-width: 240px; } .c-tr { min-width: 260px; } .c-rt { min-width: 140px; }
  .inv td { overflow-wrap: anywhere; }
  .sub-inventory { min-width: 160px; }
}
.bg-soft-inventory { background-color: rgb(240, 229, 253) !important; }
.bg-inventory { background-color: rgb(228, 206, 255) !important; }
.fullscreen { position: fixed; width: 100%; height: 100%; top: 0; left: 0; overflow: auto; background-color: white; z-index: 1001; }
.btn-exit { position: fixed; right: 1rem; top: 1rem; z-index: 999; }
</style>
